import Dates from '@root/core/src/models/dates';

export const formatAgentAvailabilityTime = (time, whiteSpaceFormat = Dates.whitespaceFormats.DEFAULT) => {
  if (!time) { return ''; }
  const hour = Number(time.split(':')[0]);
  const minutes = time.split(':')[1];

  const suffix = hour >= 12 ? 'p.m.' : 'a.m.';
  const twelveHourFormat = (hour + 11) % 12 + 1;

  if (whiteSpaceFormat === Dates.whitespaceFormats.NON_BREAKING_SPACE) {
    return `${twelveHourFormat}:${minutes}\xa0${suffix}`;
  }

  return `${twelveHourFormat}:${minutes} ${suffix}`;
};

